'use client'

import { useAction } from 'next-safe-action/hooks'

import { validateCertNum } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

export const useValidateCertNum = ({
  onSuccess,
}: {
  onSuccess: (certNum: string) => void
}) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(validateCertNum, {
    onSuccess: ({ data }) => {
      if (data?.certNum) {
        onSuccess(data.certNum)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  return action
}
